<div class="timelineHead" [ngClass]="[tripStatus | lowercase]">
    <div class="timelineHead-left">
        <div class="action time-input" *ngIf="trip.achievedPaths[0]">
            <label>Select a date
                <input type="datetime-local" [min]="cursorDateMin | formatDate: 'YYYY-MM-DDTHH:mm'" [max]="cursorDateMax | formatDate: 'YYYY-MM-DDTHH:mm'" [ngModel]="cursorDate | formatDate: 'YYYY-MM-DDTHH:mm'" (ngModelChange)="updateCursorDate($event)">
            </label>
        </div>
        <div class="action eta-input">
            <label>
                <input type="checkbox" [(ngModel)]="showAllEtas">
                <i class="fa checkbox-icon" [ngClass]="[showAllEtas ? 'checked' : 'unchecked']"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.eta-input'"></span>
            </label>
        </div>
    </div>
    <div class="timelineHead-middle">
        <div class="trip-status" [ngClass]="[tripStatus | lowercase]" [class._active]="refreshing" (click)="refreshStatus()"
             [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.trip-timeline.refresh' }]">
            <span class="text-capitalize" [i18n]="'realtime-tracking.common.trip-status.'+tripStatus | lowercase"></span>
            <i class="fas fa-sync"></i>
        </div>
    </div>
    <div class="timelineHead-right">
        <div class="action legend-help">
            <i class="fa fa-info-circle"></i>
            <small>
                <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.help.click'"></span><br>
                <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.help.cursor'"></span>
            </small>
        </div>
        <div class="action legend-input">
            <label>
                <input type="checkbox" [(ngModel)]="showLegend">
                <i class="fa checkbox-icon" [ngClass]="[showLegend ? 'checked' : 'unchecked']"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.show'"></span>
            </label>
        </div>
        <div class="action focus">
            <div (click)="switchZoom()">
                <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.focus'"></span><i class="fa fa-expand"></i>
            </div>
        </div>
    </div>
</div>

<div class="timelineContainer">
    <div class="trip-progress">
        <div class="trip-status">
            <div class="trip-bar">
                <div class="bar-wrapper" id="bar-wrapper">
                    <div class="bar" *ngIf="ready" [ngStyle]="{'width': zoomActive ? 100*zoom+'%' : '100%'}">
                        <div class="cursor">
                            <div class="cursor-icon" *ngIf="tripAchievedPath.length">
                                <div class="vehicle-name" [ngStyle]="{'left': pingEnd+'%'}">{{lastVehicle}}</div>
                                <div class="vehicle-name" [ngStyle]="{'left': cursor+'%'}">{{vehicleName}}</div>
                                <i class="lastPing" [ngStyle]="{'left': 'calc('+pingEnd+'% - 20px)'}"></i>
                            </div>
                            <input class="custom-slider" type="range" step="0.001"
                                   *ngIf="tripAchievedPath.length && !trip.isPlanned()"
                                   [min]="pingStart"
                                   [max]="pingEnd"
                                   [title]="''"
                                   [(ngModel)]="cursor"
                                   (ngModelChange)="cursorChanged()"
                                   [ngStyle]="{'left': 'calc('+pingStart+'% - 20px)', 'width': 'calc('+(pingEnd - pingStart)+'% + 40px)'}">
                        </div>
                        <div class="values-wrapper" [ngClass]="[trip.status | lowercase]" #wrapper>
                            <div class="planning-range" *ngIf="trip.loadPlanningEnd"
                                 [ngStyle]="{'left': planningStartPos+'%', 'width': planningEndPos+'%'}"
                                 [title]="(trip.loadPlanningStart | formatDate : 'D MMM LT') + ' ' + (trip.loadPlanningEnd | formatDate : 'D MMM LT')">
                            </div>

                            <div class="timeline" *ngFor="let timeline of timelineSegments; let i = index"
                                 [ngClass]="[timeline.first ? 'first' : '', timeline.last ? 'last' : '', zoomActive ? 'focus' : '']"
                                 [ngStyle]="{'width': (timeline.duration+(zoomActive ? 0 : remainingSpace))+'%', 'left': zoomActive ? timeline.pos+'%' : 'auto'}">

                                <div class="value" *ngFor="let zone of timeline.zones"
                                     [class._active]="zone.info?.active"
                                     [ngClass]="['value', zone.class]"
                                     [ngStyle]="{
                                        'left': zone.class == 'eta' ? 'calc('+zone.pos+'% - 1px)' : zone.pos+'%',
                                        'width': zone.class == 'eta' ? '2px' : zone.duration+'%'
                                     }"
                                     [popover]="popTemplate"
                                     containerClass="_largeMaxWidth"
                                     placement="top"
                                     container=".main-content"
                                     [outsideClick]="true"
                                     (onShown)="showContextualInfoOfTimelineElement(zone, i)">
                                </div>

                                <div class="events">
                                    <ng-container *ngFor="let event of timeline.events">
                                        <div class="event"
                                             *ngIf="showAllEtas || event.type !== TimelineEventType.ETA"
                                             [class._active]="event.info.active"
                                             [ngClass]="[event.type | lowercase]"
                                             [ngStyle]="{'left': event.pos+'%'}"
                                             [popover]="popTemplate"
                                             containerClass="_largeMaxWidth"
                                             placement="top"
                                             container=".main-content"
                                             [outsideClick]="true"
                                             (onShown)="showContextualInfoOfTimelineElement(event, i)">

                                        </div>

                                    </ng-container>
                                </div>

                                <div class="time">
                                    <div class="time-entry scale" *ngFor="let scale of timeline.scales"
                                         [ngClass]="[scale.type]"
                                         [class.eta]="scale.type !== 'scale'"
                                         [ngStyle]="{'left': scale.pos+'%'}">
                                        <div *ngIf="scale.type === 'scale'" [ngClass]="[scale.type]">
                                            <span>{{scale.date | formatDate: 'D MMM'}}</span>
                                            <br/>
                                            <span>{{scale.date | formatDate: 'LT'}}</span>
                                        </div>
                                        <span *ngIf="scale.type !== 'scale'" class="eta" [ngClass]="[scale.type]">{{'ETA '+ (scale.date | formatDate : 'D MMM')+' '+(scale.date | formatDate: 'LT')}}</span>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngFor="let timeline of timelineSegments; let i = index">
                                <div class="separation-container" *ngIf="!timeline.last"
                                     [class._active]="noDataSegments[i].active"
                                     [ngStyle]="{'left': getNoDataZonePosition(i)+'%',
                                                'width.%': zoomActive ? (timelineSegments[i+1].pos - (timelineSegments[i].pos+timelineSegments[i].duration))+'' : '2'}"
                                     [popover]="popTemplate"
                                     containerClass="_largeMaxWidth"
                                     placement="top"
                                     container=".main-content"
                                     [outsideClick]="true"
                                     (onShown)="showContextualInfoNoDataSegment(i)">
                                    <div class="separation"></div>
                                </div>
                            </ng-container>
                            <div class="handover" *ngFor="let handoverZone of handoverZones; let i = index"
                                 [class._active]="handoverZone.zone.info.active"
                                 [ngStyle]="{
                                    'left': (zoomActive ? handoverZone.zone.pos : handoverZone.zone.pos+(handoverZone.zone.pos*(remainingSpace)/100))+'%',
                                    'width': (zoomActive ? handoverZone.zone.duration : handoverZone.zone.duration + (handoverZone.inSameTimeline ? 0 : -1))+'%'
                                 }"
                                 [popover]="popTemplate"
                                 containerClass="_largeMaxWidth"
                                 placement="top"
                                 container=".main-content"
                                 [outsideClick]="true"
                                 (onShown)="showContextualInfoOfHandover(handoverZone)">
                            </div>
                            <ng-template #popTemplate class="info-container">
                                <app-trip-info
                                    [info]="info"
                                    [etaInfos]="etaInfos"
                                    [type]="eventType"
                                    [focus]="zoomActive"
                                    [zoom]="zoom"
                                    [distanceUnit]="distanceUnit | lowercase">
                                </app-trip-info>
                            </ng-template>
                        </div>
                        <div class="cursorTime" *ngIf="trip.achievedPaths[0]">
                            <div class="cursor-icon">
                                <div class="schedule-drag" [ngStyle]="{'left': cursor+'%'}">{{cursorDate | formatDate: 'LT'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="legend-start" *ngIf="showLegend">
        <div class="legend-head">
            <div class="legend-title">
                <h3>Legend</h3>
            </div>

            <ul class="legend-tabs">
                <li [class._active]="legendTab === 0" (click)="legendTab = 0">
                    <a [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.tabs.time-slots'"></a>
                </li>
                <li [class._active]="legendTab === 1" (click)="legendTab = 1">
                    <a [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.tabs.markers'"></a>
                </li>
                <li [class._active]="legendTab === 2" (click)="legendTab = 2">
                    <a [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.tabs.events'"></a>
                </li>
            </ul>
        </div>

        <div class="legend-list" *ngIf="legendTab === 0">
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item standby"></div>
                        <div class="legend-label standby" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.standby-zone'"></div>
                    </li>
                    <li>
                        <div class="legend-item stop"></div>
                        <div class="legend-label stop" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.standstill'"></div>
                    </li>
                    <li>
                        <div class="legend-item moving"></div>
                        <div class="legend-label moving" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.moving'"></div>
                    </li>
                    <li>
                        <div class="legend-item planning"></div>
                        <div class="legend-label planning" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.planning'"></div>
                    </li>
                </ul>
            </div>
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item waiting"></div>
                        <div class="legend-label waiting" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.waiting'"></div>
                    </li>
                    <li>
                        <div class="legend-item no-data"><div class="no-data-logo"></div></div>
                        <div class="legend-label no-data" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.no_data'"></div>
                    </li>
                    <li>
                        <div class="legend-item handover"></div>
                        <div class="legend-label handover" [i18n]="'realtime-tracking.common.load-handover.handover'"></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="legend-list" *ngIf="legendTab === 1">
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item"><img src="/assets/marker-trailer-normal.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.cursor'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-trailer-selected.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.last-ping'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-departure-chep-center.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.departure'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-arrival-chep-center.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.arrival'"></div>
                    </li>
                </ul>
            </div>
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item"><img src="/assets/marker-departure-chep-center.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.center'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-departure-customer.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.customer'"></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="legend-list" *ngIf="legendTab === 2">
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item"><img src="/assets/marker-check-in-event.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.checkin'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-check-out-event.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.checkout'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-primary-eta-red.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.primary-eta-late'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-primary-eta-green.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.primary-eta-on-time'"></div>
                    </li>
                </ul>
            </div>
            <div class="legend-col">
                <ul class="legend-items">
                    <li>
                        <div class="legend-item"><img src="/assets/marker-secondary-eta.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.eta-event'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-handover-complete-event.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.load-handover.handover'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-handover-drop-event.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.load-handover.released'"></div>
                    </li>
                    <li>
                        <div class="legend-item"><img src="/assets/marker-handover-pick-event.svg"/></div>
                        <div class="legend-label" [i18n]="'realtime-tracking.common.load-handover.taken'"></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
